<template>
  <b-container class="p-3" fluid>
    <b-alert
      :show="errorMessage"
      variant="danger"
      dismissible
      fade
      v-html="errorMessage"
    />
    <b-row>
      <b-col>
        <b-card-group v-if="$auth.user().role === 'coordinator' && (project && project.status === 'DraftForCloseProjectApproval')" class="mb-3">
          <b-card>
            <b-card-body>
              <b-card-title>
                <font-awesome-icon icon="file-excel" />
                นำเข้าจากไฟล์
              </b-card-title>
              <b-form-group>
                <template slot="label" label-for="input-1">
                  อัพโหลดไฟล์รายชื่อคณะทำงาน/ผู้เข้าร่วมโครงการ (<a href="/resources/Participants.xlsx">ดาวน์โหลดไฟล์เทมเพลตที่นี่</a>)<br>
                  <small class="text-danger">หมายเหตุ: หากมีการนำเข้ารายชื่อด้วยไฟล์ Excel ในภายหลัง รายชื่อที่ถูกเพิ่มแบบรายบุคคลจะหายไป</small>
                </template>
                <template slot="description">รองรับเฉพาะไฟล์ .xls หรือ .xlsx เท่านั้น</template>
                <b-form-file
                  v-model="file"
                  accept=".xlsx, .xls"
                  placeholder="เลือกไฟล์..."
                  drop-placeholder="วางไฟล์ลงที่นี่..."
                />
              </b-form-group>
              <b-button block variant="primary" @click="submit">
                <font-awesome-icon icon="upload" />
                อัปโหลดไฟล์
              </b-button>
            </b-card-body>
          </b-card>
          <b-card>
            <b-card-body class="d-flex flex-column h-100">
              <b-card-title>
                <font-awesome-icon icon="users" />
                นำเข้าจากระบบทรานสคริปกิจกรรม
              </b-card-title>
              <div style="flex-grow: 1">
                สำหรับนำเข้ารายชื่อคณะทำงานและผู้เข้าร่วมโครงการจากระบบทรานสคริปกิจกรรม<br>
                <small class="text-muted">ฟังก์ชั่นนี้จะใช้ได้เฉพาะกิจกรรมที่ถูกสร้างผ่านระบบขออนุมัติฯเท่านั้น</small>
              </div>
              <b-button
                v-b-modal.confirmSyncModal
                class="mt-3 float-left"
                block
                size="md"
                variant="primary"
              >
                <font-awesome-icon icon="sync" />
                นำเข้ารายชื่อ
              </b-button>
            </b-card-body>
          </b-card>
          <b-card>
            <b-card-body class="d-flex flex-column h-100">
              <b-card-title>
                <font-awesome-icon icon="user" />
                เพิ่มผู้เข้าร่วมรายบุคคล
              </b-card-title>
              <div style="flex-grow: 1">
                สำหรับเพิ่มรายชื่อผู้เข้าร่วมโครงการเป็นรายบุคคล<br>
                <small class="text-danger">หมายเหตุ: หากมีการนำเข้ารายชื่อด้วยไฟล์ Excel ในภายหลัง รายชื่อที่ถูกเพิ่มแบบรายบุคคลจะหายไป</small>
              </div>
              <b-button
                v-b-modal.addParticipantModal
                class="mt-3 float-left"
                block
                size="md"
                variant="primary"
              >
                <font-awesome-icon icon="plus" />
                เพิ่มรายชื่อผู้เข้าร่วมโครงการ
              </b-button>
            </b-card-body>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card no-body class="mb-2">
          <h6 slot="header" class="mb-0">
            <font-awesome-icon icon="table" />ตารางแสดงผู้เข้าร่วมโครงการ
          </h6>
          <table v-if="project" class="table mb-0">
            <thead>
              <tr>
                <th class="text-center" width="10%">ลำดับ</th>
                <th class="text-center" width="20%">รหัสนักศึกษา</th>
                <th class="text-center">ชื่อ-นามสกุล</th>
                <th class="text-center" width="10%">ประเภท</th>
                <th class="text-center" width="10%">ที่มา</th>
                <th class="text-center" width="10%">การกระทำ</th>
              </tr>
            </thead>
            <tbody v-if="project.participants.length">
              <tr
                v-for="(participant, index) in project.participants"
                :key="index"
              >
                <td class="text-center">{{ index + 1 }}</td>
                <td class="text-center">
                  <input type="hidden" :value="participant.studentId">
                  {{ participant.studentId }}
                </td>
                <td class="text-left">{{ participant.name }}</td>
                <td class="text-center">{{ participant.type }}</td>
                <td class="text-center">
                  <font-awesome-icon v-if="participant.source === 'excel'" title="นำเข้าจากไฟล์ Excel" :icon="['fa', 'file-excel']" />
                  <font-awesome-icon v-if="participant.source === 'manual'" title="เพิ่มแบบรายบุคคล" :icon="['fa', 'user']" />
                  <font-awesome-icon v-if="participant.source === 'api'" title="นำเข้าจากระบบทรานสคริปกิจกรรม" :icon="['fa', 'users']" />
                </td>
                <td class="text-center">
                  <div v-if="participant.source === 'manual'">
                    <b-button
                      class=""
                      size="sm"
                      :variant="'warning'"
                      @click="editingParticipant = participant; editingParticipantIndex = index"
                    >
                      แก้ไข
                    </b-button>
                    <b-button
                      class="ml-2"
                      size="sm"
                      :variant="'danger'"
                      @click="removeIndividualParticipant(participant.studentId)"
                    >
                      ลบ
                    </b-button>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6" class="text-center text-muted">ไม่มีรายชื่อผู้เข้าร่วมโครงการ</td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>
    </b-row>
    <add-participant-modal
      id="addParticipantModal"
      @finish="refetch"
    />
    <edit-participant-modal
      id="editParticipantModal"
      :participant="editingParticipant"
      :index="editingParticipantIndex"
      @close="editingParticipant = null; editingParticipantIndex = null"
      @cancel="refetch"
    />
    <sync-attendant-list-modal
      id="confirmSyncModal"
    />
  </b-container>
</template>
<script>
import gql from 'graphql-tag'
import AddParticipantModal from '@/components/project/evaluation/AddParticipantModal'
import EditParticipantModal from '@/components/project/evaluation/EditParticipantModal'
import SyncAttendantListModal from '@/components/project/evaluation/SyncAttendantListModal'

export default {
  components: { AddParticipantModal, EditParticipantModal, SyncAttendantListModal },
  apollo: {
    project: {
      query: gql`query GetProject($id: ID!) { project(id: $id) { status participants { studentId, name, type, source } } }`,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  data () {
    return {
      file: null,
      errorMessage: null,
      editingParticipant: null,
      editingParticipantIndex: null
    }
  },
  methods: {
    async submit () {
      this.errorMessage = null
      if (this.file === '' || this.file === null) {
        this.$bvToast.toast('กรุณาเลือกไฟล์ที่ต้องการอัปโหลด', {
          title: 'แจ้งเตือน',
          variant: 'danger',
          solid: true
        })
        return
      }

      await this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!, $file: Upload!) {
              projectParticipantAdd(id: $id, file: $file) {
                id
              }
            }
          `,
          variables: { id: this.$route.params.id, file: this.file }
        })
        .then(() => {
          this.$bvToast.toast('นำเข้ารายชื่อจากไฟล์ Excel สำเร็จ', {
            title: 'สำเร็จ',
            variant: 'success',
            solid: true
          })
        })
        .catch((error) => {
          let { graphQLErrors } = error
          if (graphQLErrors[0].extensions.category === 'custom') {
            this.errorMessage = graphQLErrors[0].message
          } else {
            this.errorMessage = 'เกิดข้อผิดพลาดในการอัปโหลด'
          }
        })
      this.refetch()
    },
    refetch () {
      this.$apollo.queries.project.refetch()
    },
    async removeIndividualParticipant (studentId) {
      this.$bvModal.msgBoxConfirm('ต้องการลบรหัสนักศึกษา ' + studentId + ' หรือไม่?', {
        title: '',
        okVariant: 'danger',
        okTitle: 'ลบ',
        cancelTitle: 'ยกเลิก',
        centered: true
      }).then(async value => {
        if (value === true) {
          await this.$apollo.mutate({
            mutation: gql`mutation($id: ID!, $studentId: String!) { projectRemoveIndividualParticipant(id: $id, studentId: $studentId) { id } }`,
            variables: { id: this.$route.params.id, studentId: studentId }
          })
          this.$bvToast.toast('ลบรหัสนักศึกษา ' + studentId + ' สำเร็จ', {
            title: 'สำเร็จ',
            variant: 'success',
            solid: true
          })
          this.refetch()
        }
      })
    }
  }
}
</script>
